import React from "react";
import Header from "@/components/Header";
import KnowledgeBaseSection from "@/components/KnowledgeBaseSection";
import { HomeInteractiveDemo } from "@/components/home/HomeInteractiveDemo";
import SolutionsShowcase from "@/components/home/SolutionsShowcase";
import Pricing from "@/pages/Pricing";
import Testimonials from "@/components/Testimonials";
import FAQAndContactSection from "@/components/home/FAQAndContactSection";
import Footer from "@/components/Footer";
import MaintenanceBanner from "@/components/MaintenanceBanner";
import BackToTop from "@/components/BackToTop";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <SEO
        title="Mi Asistente Legal IA - Sistema Operativo Legal con IA en Colombia"
        description="Optimiza tu práctica jurídica con IA. Cobranza en Cartera PH, calculadoras judiciales automáticas y consultas en más de 1.8M de archivos de jurisprudencia."
        keywords="asistente legal, inteligencia artificial, cartera ph, calculadoras judiciales, jurisprudencia colombia, contratos ia, altas cortes"
      />
      <MaintenanceBanner />
      <Header />
      <main className="flex-grow">
        <HomeInteractiveDemo />
        <KnowledgeBaseSection />
        <SolutionsShowcase />
        <Pricing />
        <Testimonials />
        <FAQAndContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Index;

